// extracted by extract-css-chunks-webpack-plugin
module.exports = {"accordion":"_1FeOC0","icon":"g42CLM","imageWrapper":"_1BAtaj","accordionContent":"GC2tdt","grid":"B331v4","gridItem":"_1JxUfB"};